import Css from "./style.module.scss";

import EditDocumentUtils from "utils/EditDocument";
import React, { useMemo } from "react";

const SimpleBlock = (props) => {
  const {
    block,
    pageLayoutData
  } = props;

  const coords = useMemo(() => {
    return EditDocumentUtils.getBlockRenderCoords(block.boundingBox, pageLayoutData);
  }, [block.boundingBox, pageLayoutData]);

  return (
    <div className={Css.simpleBlock} style={coords} />
  );
};

export default SimpleBlock;
